/* global Config */

// Vendor Libs
import React from 'react';
import {Provider} from 'react-redux';
import {LocationProvider, Router} from '@reach/router';
import {SnackbarProvider} from 'notistack';
import {hot} from 'react-hot-loader/root';

// Styles
import './styles/styles.scss';

// Redux
import store, {history} from './redux/store';

// Components
import Asset from './components/asset';
import Folder from './components/folder';
import Genre from './components/genre';
import Main from './components/layout/main';
import Network from './components/network';
import NoMatch from './components/layout/no-match';
import Series from './components/series';
import Storefront from './components/storefront';

const basePath = Config.base.basePath || '/';

const App = () => (
  <Provider store={store}>
    <SnackbarProvider
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      maxSnack={5}
    >
      <LocationProvider history={history}>
        <Router>
          <Main path={basePath}>
            <Asset path="assets/*" />
            <Folder path="folders/*" />
            <Genre path="genres/*" />
            <Network path="networks/*" />
            <Network path={basePath} />
            <Series path="series/*" />
            <Storefront path="storefronts/*" />
            <Logout path="logout/*" />
            <NoMatch default={true} />
          </Main>
        </Router>
      </LocationProvider>
    </SnackbarProvider>
  </Provider>
);

const Logout = () => <h3>Logging out...</h3>;
export default Config.base.env === 'development' ? hot(App) : App;
